// extracted by mini-css-extract-plugin
module.exports = {"page-content":"test_page-content__1JTjz"};